import { render, staticRenderFns } from "./ReturnToFmcForm.vue?vue&type=template&id=412cfd84&scoped=true&"
import script from "./ReturnToFmcForm.vue?vue&type=script&lang=js&"
export * from "./ReturnToFmcForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412cfd84",
  null
  
)

export default component.exports